/*
  Created By Muhammad Hassaan
  Date 10 April 2023
*/
import PropTypes from "prop-types";
import { Dialog, DialogTitle, Paper } from "@mui/material";
import Draggable from "react-draggable";
import { Close } from "@mui/icons-material";
import classNames from "classnames";
import { defaultLabelColors } from "../../utils/constants";
import { useEffect, useRef, useState } from "react";

function PaperComponent(props: any) {
  return <Paper {...props} />;
}

function DraggablePaperComponent(props: any) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export function DraggableDialog(props: any) {
  const {
    handleClose,
    open,
    maxWidth,
    classes,
    dialog_title,
    draggable,
    dialogBody,
    dialogFooter,
    dialog_style,
    Width,
  } = props;

  const [draggableEnabled, setDraggableEnabled] = useState(false);
  const dialogRef = useRef<HTMLDivElement | null>(null);

  // Enable draggable on title click
  const handleTitleClick = () => {
    setDraggableEnabled(true);
  };
  useEffect(()=>{
setDraggableEnabled(false);
  },[open===true])

  // Disable draggable if click is outside the dialog
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const dialogPaper = document.querySelector(".MuiDialog-paper"); // gets the open dialog's paper element

      if (dialogPaper && !dialogPaper.contains(event.target as Node)) {
        setDraggableEnabled(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);


  return (
    <div>
      <Dialog
        disableScrollLock={false}
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          setDraggableEnabled(false);
          handleClose();
        }}
        fullWidth
        style={dialog_style}
        maxWidth={maxWidth}
        PaperComponent={
          draggable && draggableEnabled === true
            ? DraggablePaperComponent
            : PaperComponent
        }
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          ref: dialogRef,
          sx: {
            borderRadius: "16px",
            width: Width ? Width : "auto",
          },
        }}
      >
        <DialogTitle
          id="draggable-dialog-title"
          onClick={handleTitleClick}
          style={{
            cursor: draggable && draggableEnabled ? "move" : "auto",
            fontFamily: "montserrat-Bold",
            fontSize: 20,
            color: defaultLabelColors.main_font,
            borderBottom: "none",
            border: "none",
          }}
        >
          <div
            className={classes?.display_flex_baseline}
            style={{ display: "flex", border: "none" }}
          >
            <span
              style={{
                flex: 1,
                fontFamily: "montserrat-Bold",
                fontSize: 20,
              }}
              className={classNames("Raleway-Extra-Bold")}
            >
              {dialog_title}
            </span>
            <Close
              style={{ cursor: "pointer", color: "#6F6F6F", fontSize: 20 }}
              className={classNames("Raleway-Variable")}
              onClick={handleClose}
            />
          </div>
        </DialogTitle>
        {dialogBody}
        {dialogFooter}
      </Dialog>
    </div>
  );
}

DraggableDialog.defaultProps = {
  open: false,
  maxWidth: "md",
  dialog_title: "",
  handleClose: () => {},
  classes: {},
  draggable: true,
  dialog_style: {},
};

DraggableDialog.propTypes = {
  maxWidth: PropTypes.string,
  dialog_title: PropTypes.any,
  classes: PropTypes.any,
  draggable: PropTypes.bool,
  dialogBody: PropTypes.any.isRequired,
  dialogFooter: PropTypes.any.isRequired,
  dialog_style: PropTypes.any,
  Width: PropTypes.any,
};

export default DraggableDialog;
